import { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { publicRoutes, privateRoutes } from "Router/Routes";
import Loader from "Components/Shared/Loader";
import { Container } from "@mui/material";
import WrapHeader from "Components/Shared/wrapHeader";
import WrapContainer from "Components/Shared/wrapContainer";
import BodyWrapper from "./BodyWrapper";

import { useUserContext } from "Hooks/UserContext";
import { MenuList } from "Static/utils/menuList";
import { SUPER_ADMIN } from "Static/utils/commonUtils";
import { BodyContainer } from "Helpers/overrides";

/**
 * Body of loggedIn User
 * @returns Body of the application
 */
const AdminBody = () => {
  const { userDetails } = useUserContext();
  const CurrentUserRole = userDetails
    ? userDetails.role_slug === SUPER_ADMIN
      ? userDetails.role_slug
      : "User"
    : "";
  const navigate = useNavigate();
  // Function will check and redirect if user do not have permission of selected module

  useEffect(() => {
    var slugPermission = JSON.parse(localStorage.getItem("slugPermission"));
    if (slugPermission) {
      const permissionsList = slugPermission.map((ele) => ele.module_slug);

      const currentMenuFromList = searchMenu(MenuList, location.pathname);

      // if (currentMenuFromList === null) {
      //   navigate("/", { state: { from: null }, replace: true });
      // } else {
      if (
        currentMenuFromList &&
        permissionsList.length &&
        !["/admin/home", "/admin/home/"].includes(location.pathname) &&
        !permissionsList?.includes(currentMenuFromList?.module_slug)
      ) {
        navigate("/", { state: { from: null }, replace: true });
      }
      // }
    }
  }, [location.pathname, localStorage.getItem("slugPermission")]);
  // Function will search menu and return the list
  const searchMenu = (menuItems, term, parent = null) =>
    menuItems.reduce((result, menuItem) => {
      if (!result && menuItem.path === term) {
        return menuItem;
      }

      if (menuItem.list && menuItem.list.length > 0) {
        return result || searchMenu(menuItem.list, term, menuItem);
      }

      return result;
    }, null);

  return (
    <BodyContainer px={{ sm: 3, xs: 0 }} py={2}>
      <Container maxWidth={false} className="App">
        <Suspense fallback={<Loader />}>
          <Routes>
            {privateRoutes[CurrentUserRole] &&
              privateRoutes[CurrentUserRole].map(({ path, ComponentIn, header = false }, key) => {
                return (
                  <Route
                    key={key}
                    path={path}
                    caseSensitive
                    match="exact"
                    element={
                      <BodyWrapper>
                        <ComponentIn />
                      </BodyWrapper>
                    }
                  />
                );
              })}

            {publicRoutes.map(({ path, ComponentIn, header = false }, key) => {
              return (
                <Route
                  key={key}
                  path={path}
                  element={
                    header ? (
                      <WrapHeader>
                        <WrapContainer maxWidth={header}>
                          <ComponentIn />
                        </WrapContainer>
                      </WrapHeader>
                    ) : (
                      <WrapContainer maxWidth={header}>
                        <ComponentIn />
                      </WrapContainer>
                    )
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Container>
    </BodyContainer>
  );
};

export default AdminBody;
